import { MuiThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { getMaterialTheme, getTheme } from './Theme';

const ThemeProvider = ({ children, location }) => (
  <MuiThemeProvider theme={getMaterialTheme(location.pathname)}>
    <StyledThemeProvider theme={getTheme(location.pathname)}>
      {children}
    </StyledThemeProvider>
  </MuiThemeProvider>
);

ThemeProvider.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
};

export default withRouter(ThemeProvider);
